import { compile_content as compileContent } from "#scripts/tools/compile_content.js";
import { compileResources } from "#scripts/compile.js";
import { decodeIfNeeded } from "#templates/pages/content";
// import { setArticleList } from './news';

export const getArticle = async (contentId, subscriptionId) => {
	if (!contentId) {
		return;
	}

	let apiLang = "nb_no";
	switch (window.serverdata.configMeta.aim.lang) {
		case "nb":
		case "nn":
			apiLang = `${window.serverdata.configMeta.aim.lang}_no`;
			break;
		case "en":
			apiLang = "en_us";
			break;
	}
	apiLang = localStorage.getItem("currentLanguage") || apiLang;

	let apiCall = `${window.apiUrl}/PublicContentApi/find/${contentId}`;
	let apiParameters = "";
	apiCall = `${window.apiUrl}/api/Public/articles`;
	apiParameters = `/${contentId}?subscriptionId=${subscriptionId}&language=${apiLang}&includeCategories=true&getRecursiveContent=true`;
	let html = "";

  try {
    const response = await fetch(apiCall + apiParameters);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    let html = decodeIfNeeded(data.contentObject);
    // html = data.contentObject;
    // html = compileContent(html, data);
    // html = compileResources(html);
  } catch (error) {
    console.error('Fetch error:', error);
  }

	return html;
};

export const getLangForApi = () => {
	let apiLang = "nb_no";
	switch (window.serverdata.configMeta.aim.lang) {
		case "nb":
		case "nn":
			apiLang = `${window.serverdata.configMeta.aim.lang}_no`;
			break;
		case "en":
			apiLang = "en_us";
			break;
	}
	return localStorage.getItem("currentLanguage") || apiLang;
};
